exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-element[data-v-c1ba72ec]:focus,[data-v-c1ba72ec]:focus{border:3px solid orange}.my-element[data-v-c1ba72ec]:focus-within{outline:3px solid orange}", ""]);

// exports
